<template>
  <div class="flex">
    <SidebarDesktop />

    <SidebarMobile
      :is-open="isOpen"
      @sidebar:close="$emit('sidebar:close')"
    ></SidebarMobile>
  </div>
</template>

<script>
import SidebarDesktop from '@/components/SidebarDesktop'
import SidebarMobile from '@/components/SidebarMobile'

export default {
  components: { SidebarDesktop, SidebarMobile },

  props: {
    isOpen: { type: Boolean, required: true },
  },
}
</script>
